import React from 'react';
import { Box, Divider, Stack, styled, Typography, Link } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import PolicyIcon from '@mui/icons-material/Policy';
import { FaPhoneAlt } from 'react-icons/fa';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { Business, CancelOutlined, MonetizationOnOutlined } from '@mui/icons-material';
import FooterTitle from './FooterTitle';
import FooterLink from './FooterLink';
import { Colors } from '../style/theme';

const CombinedLink = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <TaskAltIcon />
    <span>Delivery</span>
    <CancelOutlined />
    <span>Cancellation &</span>
    <MonetizationOnOutlined />
    <span>Refund</span>
  </div>
);

const Footer = () => {
  const StackColumn = styled(Stack)(() => ({
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flex: 1,
    gap: 10,
    textAlign: 'center',
  }));

  const BoxRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: Colors.primary,
    color: Colors.white,
    flex: 1,
    padding: '40px 0',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 30,
    },
  }));

  return (
    <BoxRow component="footer">
      <StackColumn>
        <FooterTitle text="Contact" />
        <FooterLink text="info@innoWave.com" link="" icon={<MailOutlineIcon sx={{ mr: 1 }} />} />
        <FooterLink text="Tylect Technologies Pvt Ltd" link="https://tylect.com/" icon={<Business sx={{ mr: 1 }} />} />
        <FooterLink text="+91-9024862242" link="about#contact-us" icon={<FaPhoneAlt style={{ marginRight: '8px' }} />} />
      </StackColumn>

      <Divider orientation="vertical" flexItem />

      <StackColumn>
        <FooterTitle text="Help" />
        <FooterLink text="Terms of Service" link="termsAndConditions" icon={<HelpOutlineIcon sx={{ mr: 1 }} />} />
        <FooterLink text="Customer Support" link="about#contact-us" icon={<QuestionAnswerIcon sx={{ mr: 1 }} />} />
        <FooterLink text="Privacy Policy" link="privacyPolicy" icon={<PolicyIcon sx={{ mr: 1 }} />} />
        <FooterLink text={<CombinedLink />} link="serviceDeliveryPolicy" />
      </StackColumn>

      <Divider orientation="vertical" flexItem />

      <StackColumn>
        <FooterTitle text="About" />
        <FooterLink text="About Us" link="about" icon={<InfoOutlinedIcon sx={{ mr: 1 }} />} />
        <FooterLink text="FAQ" link="faq" icon={<QuestionAnswerIcon sx={{ mr: 1 }} />} />
      </StackColumn>

      <Divider orientation="vertical" flexItem />

      <StackColumn>
        <FooterTitle text="InnoWave API Hub" />
        <Stack direction="row" spacing={2} justifyContent="center">
          <Link
            href="#"
            variant="body2"
            sx={{
              color: Colors.white,
              '&:hover': { color: Colors.dove_gray },
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <InstagramIcon />
          </Link>
          <Link
            href="#"
            variant="body2"
            sx={{
              color: Colors.white,
              '&:hover': { color: Colors.dove_gray },
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <FacebookIcon />
          </Link>
        </Stack>
        <Typography variant="caption" component="p">
          &copy; 2024 InnoWave API Hub as <b>Tylect Technologies Pvt Ltd</b>.
        </Typography>
      </StackColumn>
    </BoxRow>
  );
};

export default Footer;
